import {AuthService} from "./AuthService";

// Admin-only Scheduler Monitor API client. Delegates to the shared AuthService
// axios layer (Token auth injected per-request); mirrors CanaryService conventions.
export class SchedulerMonitorService {

    url = `admin/scheduler/`;

    // GET admin/scheduler/ -> {jobs: [{job_name, trigger, next_run_time, snapshot_at,
    //  last_started_at, last_finished_at, last_status, last_duration_seconds, last_error}],
    //  worker: {heartbeat_at, job_count}}
    getStatus() {
        return AuthService.apiGet(this.url).then(res => res.data.data);
    }
}
